<template>
  <div class="signup-confirmation">
    <h2>Registro enviado con éxito</h2>
    <p>
      Tu solicitud de registro ha sido enviada a la BCR para su aprobación. <br>
      Para que podamos procesar tu alta deberás enviar completada y firmada la <strong>Solicitud de Servicio</strong>. <br>
      Seguí los pasos a continuación para completar el proceso.
    </p>
    <div class="steps">
      <div class="step">
        <vs-icon icon="cloud_download"></vs-icon>
        <p><strong>Descargar la Solicitud de Servicio</strong><br>
        <a href="https://rosporc.bcr.com.ar/documentos/SolicitudDeServicios-Rosporc.pdf" target="_blank" rel="noopener noreferrer">Hacé click aquí para iniciar la descarga</a></p>
      </div>
      <div class="step">
        <vs-icon icon="send"></vs-icon>
        <p>
          Optá por alguna de las 2 opciones para completar el proceso: <br>
          Papel impreso con firma hológrafa, o Pdf con firma digital. <br>
          <strong><a href="https://rosporc.bcr.com.ar/documentos/GuiaDeAlta-Rosporc.pdf" target="_blank" rel="noopener noreferrer">Seguí esta guía para completar y enviar la solicitud</a></strong>
        </p>
      </div>
      <div class="step">
        <vs-icon icon="access_time"></vs-icon>
        <p><strong>Verficá el estado de tu alta</strong> <br>
        Accediendo a la plataforma podrás ver el estado de su proceso de alta.</p>
      </div>
    </div>

    <vs-button color="primary" type="filled" @click="resetState" :to="{ name: 'login' }">Ir al incio</vs-button>
  </div>
</template>

<script>
import { mapMutations, mapState } from 'vuex'

export default {
  name: 'signup-sent-message',
  computed: {
    ...mapState( 'SignUp', {
      firstname: state => state.admin.firstname,
      lastname: state => state.admin.lastname,
      businessName: state => state.organization.businessName
    })
  },
  methods: {
    ...mapMutations('SignUp', [
      'resetState'
    ])
  }
}
</script>
